import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { Button } from "@ts-digital/vrc";
import ListFilters from "./listFilters";
import TSDialog from "../../general/dialog";
import NoSurveysCreatedImg from "../../../assets/img/richieste-nessun-dato-creato.svg";
import NoSurveysFiltersImg from "../../../assets/img/richieste-nessun-dato-da-filtri.svg";
import LoaderSimple from "../../general/loader";
import HeaderAsk from "./header";
import AskRequests from "./requests";
import AskRequestsHeader from "./requestsHeader";

const initialFilters = {
  desc: "",
  type: "",
  company: "",
  title: "",
  sort: {
    field: "createdAt",
    direction: "desc"
  }
};

/** Check if filters are different from initial situation */
const filtersNotChange = (filters) => {
  if (filters.desc === initialFilters.desc && filters.type === initialFilters.type && filters.company === initialFilters.company && filters.title === initialFilters.title && filters.sort.field === initialFilters.sort.field && filters.sort.direction === initialFilters.sort.direction)
    return true;
  return false;
};

const List = props => {
  const {    
    myType,
    onDeleteTemplate
  } = props;

  const navigate = useNavigate();
  const intl = useIntl();
  const surveys = useSelector(state => state.ask.surveys);
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [confirmDeleteTemplate, setConfirmDeleteTemplate] = useState(false);
  const [requests, setRequests] = useState([]);
  const [reminds, setReminds] = useState([]);
  const [filters, setFilters] = useState({
    desc: "",
    type: "",
    company: "",
    title: "",
    sort: {
      field: "createdAt",
      direction: "desc"
    }
  });

  function onFiltersChange(newFilters) {
    setFilters(newFilters);
  }

  function renderDeleteTemplateDialog() {
    return (
      <TSDialog
        title={<FormattedMessage id="ask.pages.list.confirmDeleteTitle" />}
        okText={<FormattedMessage id="actions.delete" />}
        type="danger"
        visible={confirmDeleteTemplate}
        onAbort={() => setConfirmDeleteTemplate(false)}
        onSubmit={e => {
          onDeleteTemplate(selectedTemplate);
          setSelectedTemplate(undefined);
          setConfirmDeleteTemplate(false);
        }}
      >
        <FormattedMessage id="ask.pages.list.confirmDeleteSubtitle" />
      </TSDialog>
    );
  }

  return (
    <div>
      <HeaderAsk myType={myType} onNewClick={() => { navigate(myType === "STUDIO" ? "/ask-edit" : "/ask-answer?from=templates"); }} />
      <div className="askList-root">
        <ListFilters filters={filters} myType={myType} filtersNotChange={filtersNotChange} onFiltersChange={onFiltersChange} requestsLength={requests.length} />
        <div className="askList-table">
          {surveys.isGettingSurveys ? (
            <div style={{ marginTop: 200 }}>
              <LoaderSimple />
            </div>
          ) : (
            requests.length > 0 && (
              <AskRequestsHeader myType={myType} />
            )
          )}
          <div className="askList-requests">
            <AskRequests
              {...props}
              requests={requests}
              setRequests={(val) => setRequests(val)}
              filters={filters}
              reminds={reminds}
              setReminds={setReminds}
            />
          </div>
        </div>
        {!surveys.isGettingSurveys
          ? requests.length === 0 && (
            <div
              className={
                "noSurveysMessage" +
                                (filtersNotChange(filters)
                                  ? ""
                                  : " fromFilters")
              }
            >
              <div className="noSurveys-icon">
                {filtersNotChange(filters) ? (
                  <img src={NoSurveysCreatedImg} alt="" />
                ) : (
                  <img src={NoSurveysFiltersImg} alt="" />
                )}
              </div>
              <div className="noSurveys-text">
                {filtersNotChange(filters) ? (
                  myType === "STUDIO" ? <span>
                    {intl.formatMessage({id: "ask.header1", defaultMessage: "Chiedi ai tuoi clienti"})}
                    <br />
                    {intl.formatMessage({id: "ask.header2", defaultMessage: "le informazioni e i file che ti occorrono"})}
                  </span> : intl.formatMessage({id: "ask.noAsk", defaultMessage: "Nessuna richiesta trovata"})
                ) : (
                  intl.formatMessage({id: "ask.noAsk2", defaultMessage: "Non ci sono richieste"})
                )}
              </div>
              <div className="noSurveys-link">
                {filtersNotChange(filters) ? (
                  myType === "STUDIO" && <Button
                    kind='secondary'
                    size="small"
                    onClick={() => navigate("/ask-edit")}
                  >
                    {intl.formatMessage({id: "ask.createFirst", defaultMessage: "Crea la tua prima richiesta"})}
                  </Button>
                ) : (
                  myType === "STUDIO" ? <span>
                    {intl.formatMessage({id: "ask.changeFilters", defaultMessage: "Prova a cambiare i filtri oppure"})}                  
                    <br />
                    <div
                      className={"linkText"}
                      onClick={() => navigate("/ask-edit")}
                    >
                      {intl.formatMessage({id: "ask.changeFiltersCreate", defaultMessage: "crea una nuova richiesta"})}                  
                                            
                    </div>
                  </span> : <span>{intl.formatMessage({id: "ask.changeFilters", defaultMessage: "Prova a cambiare i filtri oppure"})}                  </span>
                )}
              </div>
            </div>
          )
          : null}
        {renderDeleteTemplateDialog()}
      </div>
    </div>
  );
};

export default List;
